import { Navigate, Outlet, useParams } from "react-router-dom"
import { RoutePath } from "routes/Route.types"
import { isValidClassId } from "utils/classId"

const ClassIdGuard = () => {
  const { classId } = useParams()

  if (!isValidClassId(classId)) {
    return <Navigate to={RoutePath.PAGE404_NOT_FOUND} replace />
  }

  return <Outlet />
}

export default ClassIdGuard
